<template>
  <div class="supplier-recruit">
    <div class="content-center">
      <div class="recruit-card-box">
        <div class="recruit-card material">
          <div class="recruit-title">材料供应商伙伴</div>
          <div class="recruit-subtitle">精准匹配海量商机，拓展客户网络</div>
          <div class="recruit-remark">一站式管理产品与业务流程<br>申请推广曝光，便捷对接商机</div>
          <div class="operate-bar">
            <div class="button plain" @click="handleEnterSystem('material')" v-if="supplierStatus == 'Completed'">进入工作台</div>
            <div class="button" @click="handleRegister('material', supplierStatus)" v-else>成为伙伴</div>
            <div class="button text" @click="$router.push('/supplier-signature/change')" v-if="['Completed', 'Pending'].includes(supplierStatus)">认证信息</div>
          </div>
        </div>
      </div>
      <div class="recruit-card-box">
        <div class="recruit-card scheme">
          <div class="recruit-title">解决方案供应商伙伴</div>
          <div class="recruit-subtitle">精准对接垂直客户，高效促成项目落地</div>
          <div class="recruit-remark">一站式管理自有方案与对接流程<br>支持商机获取、发布与管理</div>
          <div class="operate-bar">
            <div class="button plain" @click="handleEnterSystem('scheme')" v-if="schemeStatus == 'Completed'">进入工作台</div>
            <div class="button" @click="handleRegister('scheme', schemeStatus)" v-else>成为伙伴</div>
            <div class="button text" @click="$router.push('/scheme-signature/change')" v-if="['Completed', 'Pending'].includes(schemeStatus)">认证信息</div>
          </div>
        </div>
      </div>
    </div>
    <need-login-dialog ref="need-login-dialog" inHome></need-login-dialog>
  </div>
</template>

<script>
import NeedLoginDialog from '@/components/NeedLoginDialog';
import { mapActions, mapGetters } from 'vuex';
import { getCurrentUser } from "@/api/home/home.js";

export default {
  components: { NeedLoginDialog },
  data() {
    return {
      navigaion: {
        material: {
          Completed: '/supplier/material/index',
          unCertification: '/supplier-signature/basic-info',
          Pending: '/supplier-signature/submitted',
        },
        scheme: {
          Completed: '/supplier/scheme/index',
          unCertification: '/scheme-signature/basic-info',
          Pending: '/scheme-signature/submitted',
        },
      }
    }
  },
  computed: {
    ...mapGetters(['isLoggIn', 'currentUser']),
    schemeStatus() {
      return this.currentUser?.schemeCertificationStatus;
    },
    supplierStatus() {
      return this.currentUser?.supplierCertificationStatus;
    },
  },
  mounted() {
    if (this.isLoggIn) {
      getCurrentUser().then((user) => {
        this.$store.dispatch("setCurrentUser", user?.model || null);
      });
    }
  },
  methods: {
    ...mapActions(['setLoginPopup', 'setLoginCallback']),
    handleEnterSystem(type) {
      this.$router.push(this.navigaion[type]['Completed']);
    },
    handleRegister(type, status) {
      if (this.isLoggIn) this.$router.push(this.navigaion[type][status]);
      else {
        this.setLoginPopup(true);
        this.setLoginCallback(user => {
          const status = type === 'material' ? user.supplierCertificationStatus : user.schemeCertificationStatus;
          this.$router.push(this.navigaion[type][status]);
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.supplier-recruit {
  padding-top: 64px;
  background-color: #fff;
  overflow: hidden;

  .content-center {
    display: flex;
    .recruit-card-box {
      border-radius: 12px;
      transition: all 0.3s ease;
      + .recruit-card-box {
        margin-left: 36px;
      }
      &:hover {
        transform: translateY(-10px);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      }
      .recruit-card {
        width: 622px;
        height: 247px;
        padding: 30px 46px 0;
        background-size: 100% 100%;
        opacity: 0;
        &.material {
          background-image: url('@/assets/img/home/SupplierRecruit/recruit_bg_material.png');
          transform: translateX(-10%);
          animation: fade 0.4s linear forwards;
        }
        &.scheme {
          background-image: url('@/assets/img/home/SupplierRecruit/recruit_bg_scheme.png');
          transform: translateX(10%);
          animation: fade 0.4s linear 0.2s forwards;
        }
        .recruit-title {
          font-family: @font-medium;
          font-size: 28px;
        }
        .recruit-subtitle {
          margin: 10px 0 18px;
          background: linear-gradient(to right, #2860FA, #0242B8);
          background-clip: text;
          color: transparent;
          font-family: @font-medium;
          font-size: 16px;
        }
        .recruit-remark {
          font-size: 12px;
          color: #666666;
          line-height: 22px;
        }
        .operate-bar {
          margin-top: 20px;
          display: flex;
          .button {
            height: 34px;
            padding: 0 20px;
            background: linear-gradient(to right, #3269F9, #0242B8);
            border-radius: 2px;
            font-size: 14px;
            color: #fff;
            line-height: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            user-select: none;
            transition: 0.2s ease;
            + .button {
              margin-left: 12px;
            }
            &.plain {
              color: #0343BA;
              border: 1px solid #0343BA;
              background: none;
            }
            &.text {
              background: none;
              color: #0343BA;
              font-family: @font-medium;
              padding: 0 4px;
            }
            &:hover {
              opacity: 0.7;
            }
          }
        }
      }
    }

    @keyframes fade {
      100% {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }
}
</style>
